import { z } from "zod";
import { ShortText } from "./common.js";
/**
 * Canonical stored Trend classifications. `unknown` is the default and the
 * honest value whenever direction cannot be established from comparable
 * evidence or the user's explicitly stated judgment. That judgment may be a
 * gut feeling, but it remains user-reported rather than evidence. Dates,
 * periods, percentages and explanations belong in Actual, Gap or the
 * conversation, never in Trend.
 */
export const TAGS_TREND_VALUES = [
    "unknown",
    "improving",
    "stable",
    "worsening",
];
export const TagsTrendSchema = z.enum(TAGS_TREND_VALUES);
/** User-facing label per stored value — the one source every surface renders. */
export const TAGS_TREND_LABELS = {
    unknown: "Not sure",
    improving: "Improving",
    stable: "Stable",
    worsening: "Worsening",
};
/**
 * TAGS v3 — a concise text snapshot of Metric / Actual / Gap / Standard plus a
 * canonical Trend classification. Formatting and mathematical consistency of
 * the text fields are intentionally human-reviewed; the shared contract
 * guarantees bounded text and a closed Trend vocabulary.
 */
export const TagsParamsSchema = z
    .object({
    schemaVersion: z.literal(3),
    metric: ShortText,
    trend: TagsTrendSchema.describe("Direction of the metric. Use improving, stable or worsening when comparable evidence supports it or the user explicitly chooses it as their judgment, including a gut feeling; never present user judgment as evidence. Use unknown when neither evidence nor an explicit user judgment establishes a direction. Never a date, period, percentage or explanation."),
    actual: ShortText,
    gap: ShortText,
    standard: ShortText,
})
    .strict();
export const defaultTagsParams = {
    schemaVersion: 3,
    metric: "",
    trend: "unknown",
    actual: "",
    gap: "",
    standard: "",
};
/**
 * Retired TAGS v2 (free-text Trend). It validates nothing live — the
 * 2026-09-08 migration rewrote every persisted TAGS payload to v3 — and exists
 * only so the published Player AI widget-contract catalogues that embed this
 * shape (V3–V5, resolved by exact checksum) stay byte-identical for pinned Runs.
 */
export const RetiredTagsParamsV2Schema = z
    .object({
    schemaVersion: z.literal(2),
    metric: ShortText,
    trend: ShortText,
    actual: ShortText,
    gap: ShortText,
    standard: ShortText,
})
    .strict();
//# sourceMappingURL=tags.js.map